/* MXDVS homepage hero, stage 2: Fallout effect (04.10.2026). Homepage only, loaded with defer.
   05.10.2026 (A1 to A3): the effect only plays after a click or tap on SCR0LL. Scrolling by hand (finger, trackpad,
   mouse wheel, scrollbar) never pins the hero and never plays it: the page simply scrolls.
   How it works: assets/mxdvs-hero-home.js calls window.MxHeroFx.begin() when SCR0LL is clicked. Only then does the hero
   get pinned (the page gets PIN_VH extra scroll room), and the click slide scrolls through it:
   1. the title, the description and the buttons tear and jitter (the glitch), with grain and scanlines on top.
      The video itself is only glitched when VIDEO_GLITCH asks for it: that filter is heavy on phones
   2. then it switches off like an old tube TV: a black layer closes over the picture (it is not squeezed),
      leaving a bright horizontal and vertical line that make a cross, and the cross shrinks into one glowing dot
   When the slide ends, window.MxHeroFx.finish() takes the extra room away again and moves the scroll position back
   by the same amount in the same frame, so nothing jumps. The hero is reset while it is out of view.
   During the effect the glitch logo, the icons and the news pill at the top of the homepage
   (sections/mxdvs-rail.liquid: .mxh.is-home-top and .mxh-nb.is-home-top) stay in place like the hero buttons,
   and fade out with the picture when HEADER_FADE is on. mxdvs-rail.liquid itself is not changed.
   The ruler and the SCR0LL text are part of the picture: they do not animate on their own.
   The video (.background-video-loop in layout/theme.liquid) is kept in place while the hero is pinned.
   If the hero cannot be pinned (a parent with overflow hidden), the effect does not start and the click
   simply slides the page down. */
(function () {
  'use strict';
  if (window.__mxHeroFx) return;
  window.__mxHeroFx = true;

  /* @settings */
  var CFG = {
    MODE: 'bw',        // 'bw' = black and white glitch, 'video' = the video's own colours
    PIN_VH: 70,        // length of the effect during the click slide, in % of the screen height
    GLITCH: 1,         // strength of the tearing and the split, 0 to 2
    GRAIN: 1,          // film grain, 0 to 2
    SCAN: 1,           // scanlines, 0 to 2
    TEARS: 0,          // number of light tear bands across the whole hero (over the video too)
    VIDEO_GLITCH: 'off', // 'off' = the video is not glitched (light on every phone), 'desktop' = only on screens of 990px and wider,
                         // 'all' = everywhere (the heavy SVG filter, slow on phones)
    VIDEO_BW: false,   // true = the video fades to black and white during the glitch (a light filter)
    TEXT_GLITCH: 1,    // glitch on the title, the description, the hero buttons and the phone buttons, 0 to 2 (0 = off)
    TITLE_SLICES: true, // torn slices of the title that jump sideways
    GLITCH_FULL_AT: 70,  // the glitch reaches full strength at this % of the effect (100 = only at the very end).
                         // Lower = a faster glitch. The TV switch-off below is not affected by it.
    FLICKER_MS: 60,    // ms between two new tear positions, lower = a more frantic glitch
    GRAIN_MS: 300,     // ms for one grain shuffle, lower = faster grain
    OFF_START: 60,     // the tube switch-off starts at this % of the effect
    CROSS: true,       // true = a horizontal and a vertical line (a cross), false = a horizontal line only
    LINE_PX: 2,        // thickness of the bright lines, in px
    SPLIT: 60,         // the lines start to shorten after this % of the switch-off
    DOT_GLOW: 17.5,    // px of glow around the lines and the last dot
    HEADER_FADE: true  // true = the glitch logo, the icons and the news pill fade out while the black layer closes,
                       // false = they stay fully visible until the black screen scrolls away
  };
  /* @end */

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

  function clamp(v, lo, hi) { return Math.max(lo, Math.min(hi, v)); }
  function make(tag, cls) { var n = document.createElement(tag); n.className = cls; return n; }

  /* The hero can only stay pinned when no parent clips or scrolls its content */
  function canPin(wrap) {
    for (var el = wrap.parentElement; el && el !== document.body && el !== document.documentElement; el = el.parentElement) {
      var cs = getComputedStyle(el);
      if (/(hidden|auto|scroll|clip)/.test(cs.overflowX + ' ' + cs.overflowY)) return false;
    }
    return true;
  }

  function init() {
    var wrap = document.querySelector('.header-wrapper');
    var hero = wrap && wrap.querySelector('.header');
    /* The video is not inside the hero: it is .background-video-loop in layout/theme.liquid, behind the hero */
    var media = document.querySelector('.background-video-loop');
    var heroVid = document.getElementById('MasterVideo');
    var pausedByFx = false;
    if (!wrap || !hero || reduce.matches) return;
    if (!canPin(wrap)) {
      if (window.console && console.warn) console.warn('MXDVS hero effect: a parent of the hero clips its content, so the hero cannot be pinned. Effect not started.');
      return;
    }

    var root = document.documentElement;
    /* mx-fx-on: the effect exists on this page (the ruler script stops its own scroll animation).
       mx-fx-run: the effect is playing right now (only during a click slide). */
    root.classList.add('mx-fx-on');
    var bw = CFG.MODE !== 'video';
    var running = false;

    /* ---------- layers ---------- */
    var grain = make('i', 'mx-fx-grain');
    var scan = make('i', 'mx-fx-scan');
    var dot = make('i', 'mx-fx-dot');
    var tears = [];
    var desktop = window.matchMedia('(min-width: 990px)');
    function videoFx() { return CFG.VIDEO_GLITCH === 'all' || (CFG.VIDEO_GLITCH === 'desktop' && desktop.matches); }

    /* the HTML that glitches: title, description, hero buttons, phone buttons */
    var title = hero.querySelector('.featured-collection-banner h1');
    var glitchEls = [];
    [title, hero.querySelector('.featured-collection-banner-description')].forEach(function (n) { if (n) glitchEls.push(n); });
    Array.prototype.forEach.call(hero.querySelectorAll('.featured-collection-banner-links a, .header_menu_mobile a'), function (n) { glitchEls.push(n); });
    if (title && CFG.TITLE_SLICES && CFG.TEXT_GLITCH > 0) {
      title.setAttribute('data-mx-text', title.textContent);
      hero.classList.add('mx-fx-slices');
    }
    hero.style.setProperty('--mx-tg', String(CFG.TEXT_GLITCH));
    var NSV = 'http://www.w3.org/2000/svg';
    var black = document.createElementNS(NSV, 'svg');
    var light = document.createElementNS(NSV, 'svg');
    black.setAttribute('class', 'mx-fx-black');
    light.setAttribute('class', 'mx-fx-light');
    [black, light].forEach(function (n) { n.setAttribute('aria-hidden', 'true'); n.setAttribute('preserveAspectRatio', 'none'); });
    var blackPath = document.createElementNS(NSV, 'path');
    var lightPath = document.createElementNS(NSV, 'path');
    blackPath.setAttribute('fill', '#000');
    blackPath.setAttribute('fill-rule', 'evenodd');
    lightPath.setAttribute('fill', '#fff');
    black.appendChild(blackPath);
    light.appendChild(lightPath);
    /* the grain is drawn once as a small image (an SVG noise texture redrawn every frame is too heavy for phones) */
    try {
      var nc = document.createElement('canvas'); nc.width = nc.height = 128;
      var nx = nc.getContext('2d'), img = nx.createImageData(128, 128);
      for (var gi = 0; gi < img.data.length; gi += 4) {
        var v = (Math.random() * 255) | 0;
        img.data[gi] = img.data[gi + 1] = img.data[gi + 2] = 255; img.data[gi + 3] = v < 150 ? 0 : (v - 150) * 1.4;
      }
      nx.putImageData(img, 0, 0);
      grain.style.backgroundImage = 'url(' + nc.toDataURL('image/png') + ')';
    } catch (err) { /* keeps the texture from the stylesheet */ }
    hero.appendChild(grain);
    hero.appendChild(scan);
    for (var t = 0; t < CFG.TEARS; t++) { var e = make('i', 'mx-fx-tear'); hero.appendChild(e); tears.push(e); }
    hero.appendChild(black);
    hero.appendChild(light);
    hero.appendChild(dot);
    [grain, scan, dot].forEach(function (n) { n.setAttribute('aria-hidden', 'true'); });
    tears.forEach(function (n) { n.setAttribute('aria-hidden', 'true'); });

    /* ---------- the glitch filter on the picture: torn rows and a split into a light and a dark copy ---------- */
    var holder = document.createElement('div');
    holder.innerHTML =
      '<svg width="0" height="0" style="position:absolute" aria-hidden="true" focusable="false"><filter id="mx-fx-rgb" x="-5%" y="-5%" width="110%" height="110%" color-interpolation-filters="sRGB">' +
      '<feTurbulence id="mx-fx-n" type="fractalNoise" baseFrequency="0.002 0.12" numOctaves="1" seed="7" result="n"/>' +
      '<feDisplacementMap id="mx-fx-d" in="SourceGraphic" in2="n" scale="0" xChannelSelector="R" yChannelSelector="R" result="d"/>' +
      '<feOffset id="mx-fx-l" in="d" dx="0" dy="0" result="o1"/><feOffset id="mx-fx-r" in="d" dx="0" dy="0" result="o2"/>' +
      '<feBlend in="o1" in2="d" mode="lighten" result="m"/><feBlend in="o2" in2="m" mode="darken"' + (bw ? ' result="x"/><feColorMatrix id="mx-fx-sat" in="x" type="saturate" values="1"/>' : '/>') +
      '</filter></svg>';
    document.body.appendChild(holder.firstChild);
    var fl = document.getElementById('mx-fx-l');
    var fr = document.getElementById('mx-fx-r');
    var fd = document.getElementById('mx-fx-d');
    var fn = document.getElementById('mx-fx-n');
    var fs = document.getElementById('mx-fx-sat');

    /* ---------- colours of the glitch: grey in black and white mode, sampled from the video otherwise ---------- */
    var canvas = document.createElement('canvas');
    canvas.width = canvas.height = 8;
    var ctx = canvas.getContext('2d', { willReadFrequently: true });
    function sample() {
      if (bw) return;
      try {
        var v = document.getElementById('MasterVideo') || hero.querySelector('video');
        if (!v || !v.videoWidth) return;
        ctx.drawImage(v, 0, 0, 8, 8);
        var data = ctx.getImageData(0, 0, 8, 8).data, px = [];
        for (var q = 0; q < data.length; q += 4) px.push([data[q], data[q + 1], data[q + 2], 0.299 * data[q] + 0.587 * data[q + 1] + 0.114 * data[q + 2]]);
        px.sort(function (a, b) { return a[3] - b[3]; });
        var hi = px[Math.floor(px.length * 0.88)], mid = px[Math.floor(px.length * 0.45)];
        root.style.setProperty('--mxfx-c1', 'rgb(' + hi.slice(0, 3).join(',') + ')');
        root.style.setProperty('--mxfx-c2', 'rgb(' + mid.slice(0, 3).join(',') + ')');
        root.style.setProperty('--mxfx-tear', 'rgba(' + hi.slice(0, 3).join(',') + ',0.3)');
      } catch (err) { /* a video from another domain cannot be read: the grey defaults stay */ }
    }

    /* ---------- settings to CSS ---------- */
    hero.style.setProperty('--mx-glitch', CFG.GLITCH);
    hero.style.setProperty('--mx-grain', CFG.GRAIN);
    hero.style.setProperty('--mx-scan', CFG.SCAN);
    hero.style.setProperty('--mx-dot', CFG.DOT_GLOW + 'px');

    /* ---------- pin and progress (only while running) ---------- */
    var wrapTop = 0, heroH = 0, heroW = 0, pinPx = 0, lastP = -1, ticking = false, timer = 0;
    var split = clamp(CFG.SPLIT, 5, 95) / 100;
    var gFull = clamp(CFG.GLITCH_FULL_AT, 10, 100) / 100;
    var flickerMs = Math.max(20, CFG.FLICKER_MS);
    hero.style.setProperty('--mx-grain-ms', Math.max(60, CFG.GRAIN_MS) + 'ms');
    var start = clamp(CFG.OFF_START, 0, 95) / 100;

    function rnd() { return Math.random() * 2 - 1; }
    var lastG = 0;
    function textGlitch(g) {
      var amp = CFG.TEXT_GLITCH * g;
      for (var i = 0; i < glitchEls.length; i++) {
        var el = glitchEls[i];
        if (amp <= 0) { el.style.transform = ''; el.style.opacity = ''; continue; }
        /* most frames a small jump, now and then a big one */
        var big = Math.random() < 0.25;
        el.style.transform = 'translate3d(' + (rnd() * (big ? 12 : 3) * amp).toFixed(1) + 'px,0,0) skewX(' + (big ? rnd() * 6 * amp : 0).toFixed(1) + 'deg)';
        el.style.opacity = (1 - Math.random() * 0.35 * Math.min(1, amp)).toFixed(2);
      }
      if (title && hero.classList.contains('mx-fx-slices')) {
        if (title.getAttribute('data-mx-text') !== title.textContent) title.setAttribute('data-mx-text', title.textContent);
        var t1 = Math.random() * 80, h1 = 4 + Math.random() * 16, t2 = Math.random() * 80, h2 = 4 + Math.random() * 16;
        title.style.setProperty('--mx-s1', 'inset(' + t1.toFixed(0) + '% 0 ' + Math.max(0, 100 - t1 - h1).toFixed(0) + '% 0)');
        title.style.setProperty('--mx-s2', 'inset(' + t2.toFixed(0) + '% 0 ' + Math.max(0, 100 - t2 - h2).toFixed(0) + '% 0)');
        title.style.setProperty('--mx-s1x', (rnd() * 18 * amp).toFixed(1) + 'px');
        title.style.setProperty('--mx-s2x', (rnd() * 18 * amp).toFixed(1) + 'px');
      }
    }
    function clearText() {
      for (var i = 0; i < glitchEls.length; i++) { glitchEls[i].style.transform = ''; glitchEls[i].style.opacity = ''; }
    }

    function jitter() {
      textGlitch(lastG);
      fn.setAttribute('seed', String((Math.random() * 99) | 0));
      for (var i = 0; i < tears.length; i++) {
        tears[i].style.top = (Math.random() * 100).toFixed(1) + '%';
        tears[i].style.height = (2 + Math.random() * 24).toFixed(0) + 'px';
      }
    }

    function measure() {
      heroH = hero.offsetHeight;
      heroW = hero.offsetWidth;
      black.setAttribute('viewBox', '0 0 ' + heroW + ' ' + heroH);
      light.setAttribute('viewBox', '0 0 ' + heroW + ' ' + heroH);
      pinPx = Math.round(window.innerHeight * CFG.PIN_VH / 100);
      /* the extra scroll room only exists while the effect plays */
      wrap.style.height = running ? (heroH + pinPx) + 'px' : '';
      wrapTop = wrap.getBoundingClientRect().top + window.scrollY;
      /* where the TV switch-off starts, in px from the top of the page: the click slide in mxdvs-hero-home.js reads it */
      wrap.setAttribute('data-mx-tv-start', String(Math.round(wrapTop + pinPx * start)));
      lastP = -1;
      update();
    }

    /* The picture window left open by the black layer: a cross (or a line) that thins, then shortens into a dot.
       q = how far the switch-off is (0 to 1). */
    function windowPath(q) {
      var W = heroW, H = heroH, cx = W / 2, cy = H / 2;
      var a = clamp(q / split, 0, 1);
      var b = clamp((q - split) / (1 - split), 0, 1);
      var thin = CFG.LINE_PX / 2;
      var e = Math.pow(1 - a, 2);
      var ty = thin + (H / 2 - thin) * e;                     /* half thickness of the horizontal line */
      var tx = thin + (W / 2 - thin) * e;                     /* half thickness of the vertical line */
      var ax = Math.max(tx, (W / 2) * (1 - b));               /* half length of the horizontal line */
      var ay = Math.max(ty, (H / 2) * (1 - b));               /* half length of the vertical line */
      if (b >= 0.985) return '';
      function n(v) { return v.toFixed(1); }
      if (!CFG.CROSS) {
        return 'M' + n(cx - ax) + ' ' + n(cy - ty) + 'H' + n(cx + ax) + 'V' + n(cy + ty) + 'H' + n(cx - ax) + 'Z';
      }
      return 'M' + n(cx - tx) + ' ' + n(cy - ay) + 'H' + n(cx + tx) + 'V' + n(cy - ty) + 'H' + n(cx + ax) +
             'V' + n(cy + ty) + 'H' + n(cx + tx) + 'V' + n(cy + ay) + 'H' + n(cx - tx) + 'V' + n(cy + ty) +
             'H' + n(cx - ax) + 'V' + n(cy - ty) + 'H' + n(cx - tx) + 'Z';
    }

    function update() {
      ticking = false;
      if (!running) return;
      var p = pinPx > 0 ? clamp((window.scrollY - wrapTop) / pinPx, 0, 1) : 0;
      if (p === lastP) return;
      lastP = p;
      var active = p > 0.002;
      var g = clamp(p / gFull, 0, 1); /* the glitch has its own, faster progress; the TV below keeps using p */
      lastG = g;
      hero.style.setProperty('--mx-p', p.toFixed(4));
      hero.style.setProperty('--mx-g', g.toFixed(4));
      hero.classList.toggle('mx-fx-active', active);
      hero.classList.toggle('mx-fx-done', p >= 0.999);
      var q = clamp((p - start) / Math.max(0.05, 1 - start), 0, 1);
      var off = q > 0.001;
      hero.classList.toggle('mx-fx-off', off);
      hero.style.setProperty('--mx-off', clamp(q / split, 0, 1).toFixed(3));
      if (off) {
        var win = windowPath(q), big = 'M-60 -60H' + (heroW + 60) + 'V' + (heroH + 60) + 'H-60Z';
        blackPath.setAttribute('d', win ? big + win : big);
        lightPath.setAttribute('d', win);
        lightPath.setAttribute('opacity', clamp((q / split - 0.55) / 0.4, 0, 1).toFixed(2)); /* the picture in the cross turns to pure light near the end */
      }
      /* A2: the logo, the icons and the news pill at the top stay where they are while the hero is pinned
         (they live outside the hero, in sections/mxdvs-rail.liquid), and fade out with the picture */
      var shift = clamp(window.scrollY - wrapTop, 0, pinPx);
      root.style.setProperty('--mx-top-shift', shift.toFixed(1) + 'px');
      root.style.setProperty('--mx-top-fade', CFG.HEADER_FADE ? (1 - clamp(q / split, 0, 1)).toFixed(3) : '1');
      if (media) {
        /* glitch, then burn brighter while the black layer closes; gone once the screen is black */
        media.style.transform = shift > 0 ? 'translate3d(0,' + shift + 'px,0)' : '';
        var parts = [];
        if (p > 0.004 && p < 0.999) {
          if (videoFx()) parts.push('url(#mx-fx-rgb)');
          else if (CFG.VIDEO_BW) parts.push('grayscale(' + clamp(g * 6, 0, 1).toFixed(2) + ')');
          if (q > 0) parts.push('brightness(' + (1 + clamp(q / split, 0, 1) * 0.9).toFixed(2) + ')');
        }
        media.style.filter = parts.join(' ');
        media.style.visibility = p >= 0.999 ? 'hidden' : '';
        /* the video stops decoding once the screen is black */
        if (heroVid && p >= 0.999 && !heroVid.paused) { heroVid.pause(); pausedByFx = true; }
      }
      var s = videoFx() ? g * CFG.GLITCH : 0;
      fl.setAttribute('dx', (-s * 24).toFixed(1));
      fr.setAttribute('dx', (s * 24).toFixed(1));
      fd.setAttribute('scale', (s * 90).toFixed(1));
      if (fs) fs.setAttribute('values', (1 - clamp(g * 6, 0, 1)).toFixed(2)); /* the colour drains away in the first sixth of the glitch */
      if (active && !timer) { sample(); jitter(); timer = setInterval(jitter, flickerMs); }
      if (!active && timer) { clearInterval(timer); timer = 0; }
      if (p >= 0.999 && timer) { clearInterval(timer); timer = 0; }
      if (!active || p >= 0.999) clearText();
    }

    /* Everything back to the hero as it is at the top of the page */
    function reset() {
      if (timer) { clearInterval(timer); timer = 0; }
      clearText();
      hero.classList.remove('mx-fx-active', 'mx-fx-done', 'mx-fx-off');
      ['--mx-p', '--mx-g', '--mx-off'].forEach(function (k) { hero.style.removeProperty(k); });
      root.style.removeProperty('--mx-top-shift');
      root.style.removeProperty('--mx-top-fade');
      blackPath.setAttribute('d', '');
      lightPath.setAttribute('d', '');
      fl.setAttribute('dx', '0');
      fr.setAttribute('dx', '0');
      fd.setAttribute('scale', '0');
      if (fs) fs.setAttribute('values', '1');
      if (media) {
        media.style.transform = '';
        media.style.filter = '';
        media.style.visibility = '';
      }
      lastP = -1;
    }

    /* The video plays again as soon as the hero comes back into view */
    function resumeVideo() {
      if (!heroVid || !pausedByFx) return;
      function check() {
        if (window.scrollY < wrapTop + heroH) {
          window.removeEventListener('scroll', check);
          pausedByFx = false;
          var pr = heroVid.play();
          if (pr && pr.catch) pr.catch(function () {});
        }
      }
      window.addEventListener('scroll', check, { passive: true });
      check();
    }

    /* ---------- called by the click slide in assets/mxdvs-hero-home.js ---------- */
    function begin() {
      if (running) return true;
      running = true;
      root.classList.add('mx-fx-run');
      measure();
      return true;
    }
    function finish() {
      if (!running) return;
      var y = window.scrollY;
      var into = y - wrapTop;
      running = false;
      root.classList.remove('mx-fx-run');
      wrap.style.height = '';
      /* The extra room is gone: past the effect the page moves up by the same amount (no jump),
         stopped halfway it goes back to the top of the hero */
      var target = into >= pinPx ? y - pinPx : (into > 0 ? wrapTop : y);
      window.scrollTo({ top: target, behavior: 'instant' });
      reset();
      resumeVideo();
    }
    window.MxHeroFx = { begin: begin, finish: finish, isRunning: function () { return running; } };

    window.addEventListener('scroll', function () {
      if (running && !ticking) { ticking = true; requestAnimationFrame(update); }
    }, { passive: true });
    window.addEventListener('resize', function () { if (running) measure(); });
    document.addEventListener('visibilitychange', function () {
      if (document.hidden && timer) { clearInterval(timer); timer = 0; }
      else if (!document.hidden && running) { lastP = -1; update(); }
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
